export class Range {
  public min: number;
  public max: number;

  constructor(values: number[]) {
    if (values.length !== 2) {
      throw new Error("values must have exactly two elements");
    }

    this.min = values[0];
    this.max = values[1];
  }

  public has(value: number): boolean {
    return value >= this.min && value <= this.max;
  }

  public isValid(): boolean {
    return this.min <= this.max;
  }
}
